import { useNavigate } from "react-router-dom";

const RequestDemo = ({ title }) => {
  const navigate = useNavigate();
  return (
    <section className="w-full bg-darkPurple mt-16 mb-8">
      <div className="text-white max-lg:px-4 py-8 w-full max-w-1200 lg:min-h-[408px] mx-auto flex items-center">
        <div className=" mx-auto max-sm:px-0 max-xl:px-6">
          <div className="flex flex-col lg:flex-row items-start lg:justify-between gap-8">
            <div className="max-w-[584px] lg:w-1/2 space-y-4 flex flex-col">
              <h2 className="text-2xl md:text-3xl lg:text-[32px] font-bold">
                {title || "Request a Demo"}
              </h2>
              <p className="max-sm:hidden text-sm md:text-base lg:text-lg opacity-90 max-w-[453px]">
                Interested in transforming your corporate, licensing, and
                compliance management processes?
              </p>
            </div>
            <div className="w-full lg:w-1/2 space-y-4">
              <p className="text-sm md:text-base lg:text-lg opacity-90">
                Request a demo of RegTechFlow today and discover how automation
                can take the complexity out of your business operations.
              </p>
              <div className="flex flex-col items-start justify-start">
                <button
                  onClick={() => navigate("/book-demo")}
                  className="bg-white text-darkPurple transition-colors duration-300 rounded-full py-3 px-6 font-medium"
                >
                  Coming Soon
                </button>
                <p>Launching September 2025</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequestDemo;
